export function orderBy(array, selectorFunc, isInverted = false, secondaryOrder = null)
{
    const isDateLike = (val: unknown): boolean => {
        if (val instanceof Date) return true;
        if (typeof val !== 'string') return false;
        const date = new Date(val);
        // detecting if a value is a date turns out pretty hard. e.g. new Date("5") is valid!?
        return date.getFullYear() > 2005 && date.getFullYear() < 2100;
    };

    const toTime = (val: unknown): number => {
        if (val instanceof Date) return val.getTime();
        return Date.parse(val as string);
    };

    let res = array.sort(function (a, b)
    {
        let valueA = selectorFunc(a);
        let valueB = selectorFunc(b);

        // values are equal, let use a second sorting strategy
        if (valueA == valueB && secondaryOrder)
        {
            valueA = secondaryOrder(a);
            valueB = secondaryOrder(b);
        }

        if (valueA == valueB) return 0;
        if (!valueA) return -1;

        if (isDateLike(valueA) && isDateLike(valueB)) {
            valueA = toTime(valueA);
            valueB = toTime(valueB);
        }

        // both are numbers -> subtract
        if (!isNaN(parseInt(valueA)) && !isNaN(parseInt(valueB))) return parseInt(valueA) - parseInt(valueB);

        // you cant do localeCompare() on numbers and one of these MIGHT be a number, so we have to find out which ISNT the number
        if (isNaN(parseInt(valueA))) return valueA.localeCompare(valueB);
        return -valueB.localeCompare(valueA);
    });

    if (isInverted) res = res.reverse();

    return res;
}